var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFoto = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: [_jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.576 7.6H5.6c-.328 0-.6.272-.6.6v9.6c0 .328.272.6.6.6h12.8c.328 0 .6-.272.6-.6V8.2c0-.328-.272-.6-.6-.6h-2.976L13.96 6h-3.92L8.576 7.6ZM9.6 5 8.136 6.6H5.6c-.88 0-1.6.72-1.6 1.6v9.6c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V8.2c0-.88-.72-1.6-1.6-1.6h-2.536L14.4 5H9.6Z", clipRule: "evenodd" }), _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z", clipRule: "evenodd" })] }))); };
export default SvgFoto;
